import {
  assessmentDetailsStub,
  candidatesData,
  candidatesData2,
  skills,
} from "./stub-response";

export const getAssessmentDetails = async (assessmentId: any) => {
  try {
    if (assessmentId) {
      let response = await new Promise((resolve) => {
        setTimeout(() => {
          resolve(assessmentDetailsStub);
        }, 2000);
      });
      return response;
    } else {
      return Promise.reject("Wrong Assessment Id");
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCandidatesData = async (assessmentId: any) => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        resolve(candidatesData.assessments);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getCandidatesData2 = async (assessmentId: any) => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        resolve(candidatesData2.assessments);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getSkills = async (assessmentId: any) => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        resolve(skills);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
